<template>
  <div class="col-md-11 d-flex flex-column align-items-center router-view-background">
    <div class="info-grid col-md-12">
      <div class="info-item"><span>Serviço</span><b>{{service_single.code}}</b></div>
      <div class="info-item info-item--wide"><span>Criador</span><b>{{service_single.person ? service_single.person.name : " - "}}</b></div>
      <div class="info-item info-item--wide"><span>Propriedade</span><b>{{service_single.farm ? service_single.farm.name : " - "}}</b></div>
      <div class="info-item"><span>Animais</span><b>{{!service_single.service_animals ? " 0 " : service_single.service_animals.length}}</b></div>
      <div class="info-item"><span>Emissão</span><b>{{$_formatDateTime(weightIn.date_emission)}}</b></div>
      <div class="info-item"><span>Tipo do Serviço</span><b>{{$_returnServiceKind(weightIn.kind)}}</b></div>
      <!-- a data do controle ocupa a vaga da grade (antes era um painel sozinho numa linha) -->
      <div class="info-item info-item--field">
        <date-picker 
          label="Data do Controle"
          dense
          :binding.sync="weightIn.date"
          :readOnly="false"
          :message-error="serviceDateError"
        />
      </div>
    </div>

    <div class="milking-row col-md-12 d-flex justify-content-between pt-2 pb-5"> 
      <div class="col-md-3 px-4">
        <h5>Esgotamento</h5>
        <date-picker 
          label="Data do Esgotamento"
          :binding.sync="weightIn.exhaustion_date"
          :readOnly="false"
          :message-error="exhaustionMilkingDate"
        />
        <div class="col-md-12 p-0 d-flex justify-content-between">
          <div class="mr-1">
            <p>Hora Inicial</p>
            <hour-picker 
              placeholder="hh:mm"
              :binding.sync="weightIn.exhaustion_start_hour"
              :message-error="exhaustionStartHourError"
            />
          </div>
          <div class="ml-1">
            <p>Hora Final</p>
            <hour-picker 
              placeholder="hh:mm"
              :binding.sync="weightIn.exhaustion_end_hour"
              :message-error="exhaustionEndHourError"
            />
          </div>
        </div>
      </div>

      <div class="col-md-3 px-4">
        <h5>1º Ordenha</h5>
        <date-picker 
          label="Data da 1º Ordenha"
          :binding.sync="weightIn.first_weight_date"
          :readOnly="false"
          :message-error="firstMilkingDateErrors"
        />
        <div class="col-md-12 p-0 d-flex justify-content-between">
          <div class="mr-1">
            <p>Hora Inicial</p>
            <hour-picker 
              placeholder="hh:mm"
              :binding.sync="weightIn.first_weight_start_hour"
              :message-error="firstMilkingStartHourErrors"
            />
          </div>
          <div class="ml-1">
            <p>Hora Final</p>
            <hour-picker 
              placeholder="hh:mm"
              :binding.sync="weightIn.first_weight_end_hour"
              :message-error="firstMilkingEndHourErrors"
            />
          </div>
        </div>
      </div>

      <div class="col-md-3 px-4">
        <h5>2º Ordenha</h5>
        <date-picker 
          label="Data da 2º Ordenha"
          :binding.sync="weightIn.second_weight_date"
          :readOnly="false"
          :message-error="secondMilkingErrors"
        />
        <div class="col-md-12 p-0 d-flex justify-content-between">
          <div class="mr-1">
            <p>Hora Inicial</p>
            <hour-picker 
              placeholder="hh:mm"
              :binding.sync="weightIn.second_weight_start_hour"
              :message-error="secondMilkingStartHourErrors"
            />
          </div>
          <div class="ml-1">
            <p>Hora Final</p>
            <hour-picker 
              placeholder="hh:mm"
              :binding.sync="weightIn.second_weight_end_hour"
              :message-error="secondMilkingEndHourErrors"
            />
          </div>
        </div>
      </div>

      <div class="col-md-3 px-4">
        <h5>3º Ordenha</h5>
        <date-picker 
          label="Data da 3º Ordenha"
          :binding.sync="weightIn.third_weight_date"
          :readOnly="false"
          :message-error="thirdMilkingError"
        />
        <div class="col-md-12 p-0 d-flex justify-content-between">
          <div class="mr-1">
            <p>Hora Inicial</p>
            <hour-picker 
              placeholder="hh:mm"
              :binding.sync="weightIn.third_weight_start_hour"
              :message-error="thirdMilkingStartHourErrors"
            />
          </div>
          <div class="ml-1">
            <p>Hora Final</p>
            <hour-picker 
              placeholder="hh:mm"
              :binding.sync="weightIn.third_weight_end_hour"
              :message-error="thirdMilkingEndHourErrors"
            />
          </div>
        </div>
      </div>
    </div>

    <div v-if="this.allAnimals.length > 0" class="col-md-12 px-0 mt-6">
      <div class="form-panel">
        <p class="form-panel__title"><i class="mdi mdi-table-cog"></i>Aplicar a todos e organizar a tabela</p>
        <div class="form-panel__toggles">
          <v-switch
            inset
            hide-details
            color="var(--green)"
            v-model="allHasChildren"
            label="Todos os animais usam bezerro ao pé?"
            class="m-0"
            @change="setBirthForAll"
          ></v-switch>
        </div>

        <v-select
          class="form-panel__field form-panel__field--wide"
          hide-details
          outlined
          dense
          :items="computedRegimes"
          item-text="title"
          item-value="id"
          label="Regime alimentar de todos"
          @change="setDietForAll"
        ></v-select>

        <v-select
          class="form-panel__field form-panel__field--wide"
          hide-details
          outlined
          dense
          :items="computedExplanations.filter(e => e.id === '10')"
          item-text="title"
          item-value="id"
          label="Explicação de lactação de todos"
          v-model="allExplanations"
          @change="setExplanationsForAll"
          multiple
        ></v-select>

        <!-- filtro de animais por nome e Brinco -->
        <v-text-field
          class="form-panel__field"
          outlined
          dense
          label="Pesquise"
          prepend-inner-icon="mdi-magnify"
          @input="searchAnimal"
        ></v-text-field>

        <v-select
          class="form-panel__field"
          outlined
          dense
          label="Ordenar por"
          :items="computedSortOptions"
          item-text="text"
          item-value="value"
          :value="valuePerPage"
          @change="setSort"
        ></v-select>

        <div class="form-panel__actions">
          <v-select
            outlined
            dense
            label="Exibindo"
            :items="valuesForAmount"
            item-text="title"
            item-value="value"
            :value="valuePerPage"
            @change="$_setAmount"
            style="max-width:110px"
          ></v-select>
          <span class="text-nowrap">
            <strong style="color:var(--green)">{{in_page > total_items ? total_items : in_page}}</strong>
            /
            <strong style="color:var(--green)">{{total_items}}</strong> 
            Registros
          </span>
        </div>
      </div>
    </div>

    <div v-else class="col-md-12 px-0 mt-6">
      <div class="form-panel">
        <!-- filtro de animais por nome e Brinco -->
        <v-text-field
          class="form-panel__field"
          outlined
          dense
          label="Pesquise"
          prepend-inner-icon="mdi-magnify"
          @input="searchAnimal"
        ></v-text-field>
      </div>
    </div>

    <div class="col-md-12 mt-5 pt-5 pb-5">
      <div class="col-lg-12">
        <the-table 
          id="service-list"
          :dataItems="computedAnimals"
          :headers="headersForTable"
          :key="tableKey"
        >
          <template v-slot:approvedSwitch>
            <v-select
              v-if="user.attributes.kind === 'admin'"
              outlined
              hide-details
              dense
              label="Status para todos"
              :items="computedAnimalsOptions"
              item-value="value"
              item-text="title"
              v-model="approvedAllAnimals"
              @change="approveAll(approvedAllAnimals)"
              style="min-width:160px"
            ></v-select>
          </template>
          <template v-slot:situationHeader>
            <span>Situação</span>
          </template>

          <template v-slot:dietHeader>
            <span>Regime Alimentar</span>
          </template>

          <template v-slot:childrenHeader>
            <span>Bezerro ao pé?</span>
          </template>

          <template v-slot:emptyHeader>
            <span>Esgota</span>
          </template>

          <template v-slot:firstHeader>
            <span>1º</span>
          </template>

          <template v-slot:secondHeader>
            <span>2º</span>
          </template>

          <template v-slot:thirdHeader>
            <span>3º</span>
          </template>

          <template v-slot:lactationHeader>
            <span>Lactação</span>
          </template>

          <template v-slot:approved="{item}">
            <div class="d-flex flex-column align-items-center justify-content-center">
              <v-select
                style="max-width:130px"
                outlined
                dense
                :items="approvedLevels"
                item-text="title"
                item-value="value"
                hide-details
                v-model="item.approved"
                class="table-item"
                @change="checkIfWasReproved(item)"
                :key="approvedKey"
              ></v-select>
              <p>{{item.observation ? item.observation : ""}}</p>
            </div>
          </template>

          <template v-slot:animalRemove>
            <span class="d-flex justify-content-center">Remover do Serviço</span>
          </template>
          <template v-slot:remove="{item}">
            <v-switch
              inset
              color="success"
              style="width:50px !important; height:30px; margin-left:20% !important"
              class="m-0 d-block"
              @change="() => {!item.hide_modal ? removeAnimalFromService(item) : -1}"
              v-model="item.hide_modal"
            ></v-switch>
          </template>

          <template v-slot:situation="{item}">
            <div class="d-flex flex-column">
              <div 
                class="round-icon mx-auto"
                :style="`background-color:${item.color} !important`"
                v-tooltip.top="{content:item.tooltip}"              
             ></div>
              <p class="text-center" v-if="!headersForTable.find(e => e.value === 'approved')">{{item.observation ? item.observation : ""}}</p>
            </div>
          </template>

          <template v-slot:lot="{item}">
            <v-text-field
              v-model="item.lot"
              outlined
              hide-details
              @input="setLot(item)"
            ></v-text-field>
          </template>

          <template v-slot:name="{item}">
            <div class="d-flex flex-column justify-content-center">
              <span 
                class="text-center text-decoration-underline" 
                :style="item.error ? 'color:red' : 'color:black'"
                style="cursor:pointer"
                @click="showBirthProductionInfo(item)"
              >
                {{item.name}}
              </span>
              <div v-if="item.error" class="text-center">
                <i style="color:red" class="mdi mdi-alert"></i>
                <p style="color:red">{{item.error}}</p>
              </div>
            </div>
          </template>

          <template v-slot:date_birthday="{item}">
            <span v-if="item.date_tooltip" style="color:red" v-tooltip.top="item.date_tooltip">{{item.date_birthday}}</span>
            <span v-else>{{item.date_birthday}}</span>
          </template>

          <template v-slot:regime="{item}">
            <span style="max-width:200px">
              <p class="m-0" v-if="checkIfIsApproved(item)">{{computedRegimes.find(e => e.id === item.regime) ? computedRegimes.find(e => e.id === item.regime).title : "" }}</p>
              <v-select
                v-else
                outlined
                :items="computedRegimes"
                item-text="title"
                item-value="id"
                v-model="item.regime"
                class="table-item select-adjust"
                @change="setRegime(item)"
                :disabled="(!checkIfCanEdit || checkLactaction(item))"
                :error-messages="item.low"
                v-tooltip.top="{content: item.low.length ? item.error_msg : ''}"
              ></v-select>
            </span>
          </template>

          <template v-slot:on_foot="{item}">
            <div style="display:flex; justify-content:center;">
            <v-switch
              inset
              color="var(--green)"
              v-model="item.on_foot"
              class="table-item"
              @change="setOnFoot(item)"
              :disabled="!checkIfCanEdit || checkIfIsApproved(item) || checkLactaction(item) || checkLactationOnFoot(item)"
            ></v-switch>
            </div>
          </template>

          <template v-slot:empty="{item}">
            <p class="m-0" v-if="checkIfIsApproved(item)">{{item.empty}}</p>
            <v-text-field
              v-else
              outlined
              label=""
              v-model="item.empty"
              class="table-item"
              @input="setEmpty(item)"
              :disabled="(!checkIfCanEdit || checkLactaction(item))"
            ></v-text-field>
          </template>

          <template v-slot:first_weight="{item}">
            <p class="m-0" v-if="checkIfIsApproved(item)">{{item.first_weight}}</p>
            <v-text-field
              v-else
              :key="inputKey"
              outlined
              v-model="item.first_weight"
              label=""
              class="table-item"
              @input="setFirst(item)"
              :disabled="(!checkIfCanEdit || checkLactaction(item))"
              :error-messages="item.low"
              v-tooltip.top="{content: item.low.length ? item.error_msg : ''}"
            ></v-text-field>
          </template>

          <template v-slot:second="{item}">
            <p class="m-0" v-if="checkIfIsApproved(item)">{{item.second}}</p>
            <v-text-field
              v-else
              outlined
              v-model="item.second"
              label=""
              class="table-item"
              @input="setSecond(item)"
              :disabled="(!checkIfCanEdit || checkLactaction(item))"
              :error-messages="item.low"
              v-tooltip.top="{content: item.low.length ? item.error_msg : ''}"
            ></v-text-field>
          </template>

          <template v-slot:third="{item}">
            <p class="m-0" v-if="checkIfIsApproved(item)">{{item.third}}</p>
            <v-text-field
              v-else
              outlined
              v-model="item.third"
              label=""
              class="table-item"
              @input="setThird(item)"
              :disabled="(!checkIfCanEdit || checkLactaction(item))"
              :error-messages="item.low"
              v-tooltip.top="{content: item.low.length ? item.error_msg : ''}"
            ></v-text-field>
          </template>

          <template v-slot:lact="{item}">
            <p class="m-0" v-if="checkIfIsApproved(item)">{{computedExplanations.find(e => e.id === item.lact[0]) ? 
              computedExplanations.find(e => e.id === item.lact[0]).title : ""}}</p>
            <div v-else>
              <span 
                style="max-width:50px"
                v-if="!item.lact.filter(e => e === '10' || e === '38').length"
              >
                <v-autocomplete
                  outlined
                  multiple
                  label=""
                  :items="computedExplanations"
                  item-text="title"
                  item-value="id"
                  class="mt-3"
                  v-model="item.lact"
                  @change="setLact(item)"
                  v-tooltip.top="{content: item.low.length ? item.error_msg : ''}"
                  :error-messages="item.low"
                  :disabled="!checkIfCanEdit"
                  no-data-text="Nenhum resultado..."
                  style="max-width:100px"
                ></v-autocomplete>
              </span>
              <span 
                v-else
              >
                <v-autocomplete
                  outlined
                  multiple
                  label=""
                  :items="computedExplanations"
                  item-text="title"
                  item-value="id"
                  class="mt-3"
                  v-model="item.lact"
                  @change="setLact(item)"
                  :disabled="!checkIfCanEdit"
                  no-data-text="Nenhum resultado..."
                  style="max-width:100px"
                ></v-autocomplete>
              </span>
            </div>
            
          </template>

          <template v-slot:actions="{item}">
            <div class="d-flex justify-content-center align-items-center">
              <a 
                v-if="!item.hide_milk_closure && !item.kind_explanation"
                class="text-link d-block" 
                style="color:var(--medium-blue)"
                @click="openKillsModal(item)"
              >
                Encerrar
              </a>

              <span v-if="parseFloat(item.protein) > 0 || parseFloat(item.fat) > 0">
                <a 
                  class="text-link pl-2"
                  @click="showClassification(item.animal_id)"
                >
                  <i class="mdi mdi-file-document classification-icon text-info"></i>
                </a>
              </span>

              <span v-else class="text-center">
                <small v-if="item.date_explanation && !item.hide_milk_closure" class="d-block">Data: {{parseDate(item.date_explanation)}}</small>
                <small class="d-block" v-if="item.date_explanation && !item.hide_milk_closure">Motivo: {{item.kind_explanation.name}}</small>
                <a v-if="item.date_explanation && !item.hide_milk_closure" @click="cancelClosure(item)" class="text-link">Cancelar Encerramento</a>
              </span>
            </div>
          </template>
        </the-table>
      </div>
    </div>

    <div class="col-md-12 d-flex justify-content-end" style="margin-top:5vh">
      <v-pagination
        v-model="page"
        :length="total_pages"
        :total-visible="8"
        color="var(--jersey-yellow)"
      ></v-pagination>
    </div>

    <div 
      class="col-md-12 mt-5 mb-5 d-flex justify-content-end" 
      v-if="checkIfCanValidate"
    >
      <div class="col-md-6">
        <v-text-field
          outlined
          label="Observação"
          v-model="weightIn.observation"
        ></v-text-field>
      </div>
    </div>

    <div class="col-md-12 mt-15 mb-15">
      <the-actions
        color="#4caf50"
        sub-color="#ffffff"
        action-text="Salvar Rascunho"
        path-back="Services-list"
        @save="saveDraft(true)"
        :show-save="true"
        :disabled="has_errors_first_milking"
      >
        <div class="col-md-12 d-flex justify-content-end">
          <v-btn 
            v-if="user.attributes.kind === 'admin' && (service_single.status === 'Finalizado' || service_single.status === 'Validado')"
            style="background-color:var(--jersey-yellow);color:white;"
            @click="validateWeightIn"
            :disabled="service_single.status === 'Finalizado' && hasAnimalWithoutLevel"
          >
            Validar Serviço
          </v-btn>

          <v-btn 
            v-else
            :disabled="!checkIfCanClose || has_errors_first_milking"
            class="success"
            @click="saveWeightIn"
          >
            Finalizar Pesagem
          </v-btn>
        </div>
      </the-actions>
    </div>

    <modal-add-animals 
      :isOpen="addingAnimal"
      :animals="allAnimalsList"
      :already-included="allAnimals.map(e => {return e.animal})"
      :groups="computedGroups"
      @close="addingAnimal = false"
      @push-animal="updateAnimalsList"
    />

    <modal-milk-closure
      :isOpen="isModalKills"
      :animal="animalToKill"
      :reasons="closure_reasons"
      :servideDate="weightIn.date"
      @close="closeModalKill"
      @updateAlertInterval="updateInterval"
    />

    <modal-saved-service 
      :service="weightIn"
      :active="modalSaved"
      @close="modalSaved = false"
    />

    <modal-remove-animal 
      :isOpen="showRemoveModal"
      :animal="animalToRemove"
      @close="closeRemoveModal"
      @desaprove-all="desaproveAll"
      @get-observation="getObservation"
    />

    <modal-alert-interval 
      :isOpen="modalAlertInterval"
      @close="modalAlertInterval = false"
    />

    <modal-alert-first-weight-in-interval 
      :isOpen="showInvalidFirstWeightInInterval"
      :listAnimals="invalidFirstWeightInAnimals"
      :errorMsg="firstAlertsModalText"
      :showActions="submitedOnSave"
      @close="
        showInvalidFirstWeightInInterval = false;
        submitedOnSave = false;
      "
      @save-regardless="saveWeightInRegardless"
    />

    <modal-birth-production-info 
      :isOpen="isModalBirthProductionInfo"
      :animal="animalBirthProductionInfo"
      @close="isModalBirthProductionInfo = false"
    />

    <modal-classification-info 
      :isOpen="animalClassificationInfo.show"
      :animal="animalClassificationInfo.animal"
      @close="animalClassificationInfo.show = false"
    />

    <alert-two-weights 
      :isOpen="showAlertTwoWeight"
      :animals="alertTwoWeightAnimals"
      @close="showAlertTwoWeight = false"
    />
  </div>
</template> 

<script>
import DatePicker from "@/components/layout/DatePicker";
import HourPicker from "@/components/layout/HourPicker";
import TheTable from "@/components/layout/TheTable";
import TheActions from "@/components/layout/TheActions";
import AlertTwoWeights from "./AlertTwoWeights.vue";
import {mapState, mapActions} from "vuex";
import helpers from "@/mixins/helpers.js";

// approved no banco e string (approved, approved_only_manager, approved_with_pending, unapproved ou
// "" = nao avaliado); o switch da tela e booleano.
const APPROVED_ON = ["approved", "approved_only_manager", "approved_with_pending"];
const isApprovedValue = value => value === true || APPROVED_ON.includes(value);
// 4 níveis (sistema do Rapha): o select guarda a própria string; booleano legado vira nível.
const approvedLevel = value => value === true ? "approved" : value === false ? "unapproved" : (value || "");

export default {
  name:"FormWeighIn",
  mixins:[helpers],
  data() {
    return {
      approvedAllAnimals:null,
      approvedLevels:[
        {title: "1 - Aprovado", value: "approved"},
        {title: "2 - Aprovado com pendências", value: "approved_with_pending"},
        {title: "3 - Aprovado somente para gestão", value: "approved_only_manager"},
        {title: "4 - Reprovado", value: "unapproved"},
      ],
      animalClassificationInfo:{
        show:false,
        animal:{}
      },
      showAlertTwoWeight:false,
      alertTwoWeightAnimals:[],
      firstAlertsModalText:"",
      modalAlertInterval:false,
      showExplanations:false,
      allExplanations:[],
      animalToExplanations:{},
      weightIn:{},
      filter:{},
      showInvalidFirstWeightInInterval:false,
      submitedOnSave:false,
      invalidFirstWeightInAnimals:[],
      headersForTable:[
        {text:"Situação", value:"situation", has_slot:true, header_slot:"situationHeader", index:0},
        {text:"Lote", value:"lot", has_slot: true, index:1},
        {text:"Animal", value:"name", has_slot:true, index:2},
        {text:"Brinco", value:"bottom", index:3},
        {text:"Data de Parto", value:"date_birthday", has_slot:true, index:4},
        {text:"Regime Alimentar", value:"regime", has_slot:true, header_slot:"dietHeader", index:5},
        {text:"Bezerro no pé?", value:"on_foot", has_slot:true, header_slot:"childrenHeader", type:"boolean", index:6},
        {text:"Esgota", value:"empty", has_slot:true, header_slot:"emptyHeader", index:7},
        {text:"1º", value:"first_weight", has_slot:true, header_slot:"firstHeader", index:8},
        {text:"2º", value:"second", has_slot:true, header_slot:"secondHeader", index:9},
        {text:"3º", value:"third", has_slot:true, header_slot:"thirdHeader", index:10},
        {text:"Lactação", value:"lact", has_slot:true, header_slot:"lactationHeader", index:11},
        {text:"", value:"actions", has_slot:true, show_controls:true, index:20}
      ],
      draftSaved:false,
      allHasChildren:false,
      isSearching:false,
      allAnimals:[],
      tableKey:0,
      inputKey:0,
      allDiets:"",
      amount:50,
      animalToKill:{},
      isModalKills:false,
      addingAnimal:false,
      allAnimalsList:[],
      allApproved:false,
      valuePerPage:50,
      valuesForAmount:[
        {title:"10", value:10},
        {title:"25", value:25},
        {title:"50", value:50},
        {title:"100", value:100},
      ],
      modalSaved:false,
      showRemoveModal:false,
      animalToRemove:{},
      approvedKey:0,
      blankAnimals:false,
      isModalBirthProductionInfo:false,
      animalBirthProductionInfo:{}
    }
  },
  components:{
    DatePicker,
    TheTable,
    TheActions,
    HourPicker,
    ModalMilkClosure: () => import("./ModalMilkClosure.vue"),
    ModalAddAnimals: () => import("@/components/adm/services/ModalAddAnimals.vue"),
    ModalSavedService: () => import("./ModalSavedService"),
    ModalRemoveAnimal: () => import("./ModalRemoveAnimal"),
    ModalAlertInterval: () => import("./ModalAlertInterval"),
    ModalAlertFirstWeightInInterval: () => import("./ModalAlertFirstWeightInInterval.vue"),
    ModalBirthProductionInfo: () => import("./ModalBirthProductionInfo.vue"),
    ModalClassificationInfo: () => import("./ModalClassificationInfo.vue"),
    AlertTwoWeights
  },
  computed:{
    // "Status para todos" (sistema do Rapha); "Aprovar todos" vira "Aprovado" (Altamir, call 29/09)
    computedAnimalsOptions() {
      return [
        {title: "1 - Aprovar todos os animais", value: "approved"},
        {title: "1 - Aprovar todos com pesagem", value: "with_weight"},
        {title: "2 - Aprovado com pendências", value: "approved_with_pending"},
        {title: "3 - Aprovado somente para gestão", value: "approved_only_manager"},
        {title: "4 - Reprovar todos os animais", value: "unapproved"},
      ]
    },
    // Validar só depois de cada animal ter um nível escolhido (não obriga a sobrescrever por "todos")
    hasAnimalWithoutLevel() {
      return this.allAnimals.some(e => !e.approved);
    },
    ...mapState("service", [
      "lactList", 
      "service_single", 
      "last_service",
    ]),
    ...mapState("animals", [
      "regimes", 
      "explanations",
      "down_reasons",
      "closure_reasons"
    ]),
    ...mapState("login", ["user"]),
    computedSortOptions() {
      return [
        {text:"Nome", value:"animals.name"},
        {text:"Registro", value:"animals.register"},
        {text:"Brinco", value:"animals.code"},
      ]
    },
    listSortCount() {
      if(this.allAnimals.length < this.amount) {
        return this.allAnimals.length;
      }
      if(this.computedAnimals.length > this.amount + 1) {
        return this.amount + this.computedAnimals.length; 
      }
      else {
        return this.amount;
      }
    },
    thirdMilkingError() {
      let error = [];
      this.allAnimals.forEach(e => {
        if(!this.weightIn.third_weight_date && parseFloat(e.third_weight) > 0) {
          error.push("3º ordenha é obrigatória");
        } else {
          error = [];
        }
      });
      if(this.weightIn.third_weight_date) {
        const first = Math.round(new Date(this.weightIn.first_weight_date).getTime() / 1000);
        const last_weight_in = Math.round(new Date(this.weightIn.third_weight_date).getTime() / 1000);
        if(first - last_weight_in < -86400) {
          error.push("Intervalo entra a 1º ordenha e a 3º ordenha não pode ser maior que 24h");
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.weightIn.third_weight_date = "";
        }
        if(first > last_weight_in) {
          error.push("3º Ordenha não pode ser anterior a 1º ordenha");
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.weightIn.third_weight_date = "";
        }
      }
      return error;
    },
    //Retorna os items de lactação e valida os items junto com a função de set
    computedExplanations() {
      return this.explanations;
    },
    //Verificação de permisão para fechar o serviço
    checkIfCanClose() {
      const permition = this.user.roles.find(e => e.name === "service.close");
      if(permition) {
        return true;
      } else {
        return false;
      }
    },
    checkIfCanValidate() {
      const permition = this.user.roles.find(e => e.name === "service.validate");
      if(permition) {
        return true;
      } else {
        return false;
      }
    },
    computedAnimals() {
      return [
        ...this.allAnimals
        .filter(a => !a._destroy)
        .map(e => 
        ({
          name:e.animal.name,
          lot:e.lot,
          animal_id:e.animal_id,
          item_id:e.id,
          bottom:e.animal.code,
          register:e.animal.register,
          date_birthday:e.animal.last_birthday,
          regime:e.regime,
          on_foot:e.on_foot,
          empty:e.exhaustion === 0 ? "" : e.exhaustion,
          first_weight:e.first_weight === 0 ? "" : e.first_weight,
          second:e.second_weight === 0 ? "" : e.second_weight,
          third:e.third_weight === 0 ? "" : e.third_weight,
          lact:e.lactation,
          color:e.animal.status ? e.animal.status.color : "",
          tooltip:e.animal.status ? e.animal.status.description + " - " + e.animal.status.title : "",
          has_errors:parseFloat(e.first_weight) <= 0 ? ' ' : '',
          approved: this.checkIfCanValidate ? e.approved : undefined,
          observation:e.observation,
          low:!e.low ? "" : e.low,
          error_msg:!e.error_msg ? "" : e.error_msg,
          error:e.error,
          situation:e.animal.status ? e.animal.status.title : "-",
          explanations:e.explanations ? e.explanations : undefined,
          date_explanation:!e.date_explanation ? undefined : e.date_explanation,
          kind_explanation:(!e.kind_explanation || e.kind_explanation === "") ? undefined : this.closure_reasons.find(exp => exp.id === parseInt(e.kind_explanation)),
          hide_modal:e.hide_modal,
          hide_milk_closure:e.hide_milk_closure,
          date_tooltip:e.date_tooltip,
          has_analysis:e.has_analysis,
          protein:e.protein,
          fat:e.fat
        }))
      ]
    },
    firstMilkingErrors() {
      let result = null;
      if(this.weightIn.exhaustion_date) {
        const exhaustion = Math.round(new Date(this.weightIn.exhaustion_date).getTime() / 1000);
        const first_weight_in = Math.round(new Date(this.weightIn.first_weight_date).getTime() / 1000);
        if(exhaustion - first_weight_in < -86400) {
          result = true;
        }
      } else {
        result = false;
      }
      return result;
    },
    secondMilkingErrors() {
      let result = [];
      this.allAnimals.forEach(e => {
        if(!this.weightIn.second_weight_date && parseFloat(e.second_weight) > 0) {
          result.push("2º ordenha é obrigatória");
        }
      });
      if(this.weightIn.first_weight_date && this.weightIn.second_weight_date) {
        const first = Math.round(new Date(this.weightIn.first_weight_date).getTime() / 1000);
        const second_weight_in = Math.round(new Date(this.weightIn.second_weight_date).getTime() / 1000);
        if(first - second_weight_in < -86400) {
          result.push("Intervalo entre 1º ordenha e 2º ordenha não pode ser maior que 24h");
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.weightIn.second_weight_date = "";
        }
        if(first > second_weight_in) {
          result.push("2º Ordenha não pode ser anterior a 1º ordenha");
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.weightIn.second_weight_date = "";
        }
      }
      return result;
    },
    //Validação de 1º Ordenha em date e hora das coletas
    firstMilkingDate() {
      let error =  [];
      if(!this.weightIn.first_weight_date) {
        error.push(" ");
      }
      return error;
    },
    serviceDateError() {
      if(!this.weightIn.date) {
        return [" "];
      } else {
        return [];
      }
    },
    exhaustionMilkingDate() {
      let result = [];
      this.allAnimals.forEach(e => {
        if(!this.weightIn.exhaustion_date && parseFloat(e.exhaustion) > 0) {
          result.push("Esgotamento é obrigatório");
        }
      })
      if(this.weightIn.exhaustion_date && this.weightIn.first_weight_date) {
        const exhaustion_date = Math.round(new Date(this.weightIn.exhaustion_date).getTime() / 1000);
        const first_weight_in = Math.round(new Date(this.weightIn.first_weight_date).getTime() / 1000);
        let last_milking = null;
        let last_minking_number = null;
        switch(true) {
          case this.weightIn.third_weight_date !== null : {
            last_milking = "third_weight_date";
            last_minking_number = 3;
            break;
          }
          case (this.weightIn.first_weight_date && 
          this.weightIn.second_weight_date && 
          !this.weightIn.third_weight_date) : {
            last_milking = "second_weight_date";
            last_minking_number = 2;
            break;
          }
          default : {
            last_milking = "first_weight_date";
            last_minking_number = 1;
          }
        }
        if(exhaustion_date > first_weight_in) {
          result.push("Esgotamento deve ser anterior a 1º ordenha");
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.weightIn.exhaustion_date = "";
        }
        const last_milking_date = Math.round(new Date(this.weightIn[last_milking]).getTime() / 1000);
        if(exhaustion_date - last_milking_date < -86400) {
          result.push(`Intervalo entre esgotamento e ${last_minking_number}º ordenha não pode ser maior que 24h`);
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.weightIn.exhaustion_date = "";
        }
      }
      return result;
    },
    exhaustionStartHourError() {
      let result = [];
      this.allAnimals.forEach(e => {
        if(!this.weightIn.exhaustion_start_hour && parseFloat(e.exhaustion) > 0) {
          result.push("Hora é obrigatória");
        }
      });
      return result;
    },
    exhaustionEndHourError() {
      let result = [];
      this.allAnimals.forEach(e => {
        if(!this.weightIn.exhaustion_end_hour && parseFloat(e.exhaustion) > 0) {
          result.push("Hora é obrigatória");
        }
      });
      return result;
    },
    firstMilkingDateErrors() {
      let result = [];
      this.allAnimals.forEach(e => {
        if(!this.weightIn.first_weight_date && parseFloat(e.first_weight) > 0) {
          result.push("1º ordenha é obrigatória");
        }
      });
      return result;
    },
    firstMilkingStartHourErrors() {
      let result = [];
      this.allAnimals.forEach(e => {
        if(!this.weightIn.first_weight_start_hour && parseFloat(e.first_weight) > 0) {
          result.push("Hora é obrigatória");
        }
      });
      return result;
    },
    firstMilkingEndHourErrors() {
      let result = [];
      this.allAnimals.forEach(e => {
        if(!this.weightIn.first_weight_end_hour && parseFloat(e.first_weight) > 0) {
          result.push("Hora é obrigatória");
        }
      });
      return result;
    },
    secondMilkingStartHourErrors() {
      let result = [];
      this.allAnimals.forEach(e => {
        if(!this.weightIn.second_weight_start_hour && parseFloat(e.second_weight) > 0) {
          result.push("Hora é obrigatória");
        }
      });
      return result;
    },
    secondMilkingEndHourErrors() {
      let result = [];
      this.allAnimals.forEach(e => {
        if(!this.weightIn.second_weight_end_hour && parseFloat(e.second_weight) > 0) {
          result.push("Hora é obrigatória");
        }
      });
      return result;
    },
    thirdMilkingStartHourErrors() {
      let result = [];
      this.allAnimals.forEach(e => {
        if(!this.weightIn.third_weight_start_hour && parseFloat(e.third_weight) > 0) {
          result.push("Hora é obrigatória");
        }
      });
      return result;
    },
    thirdMilkingEndHourErrors() {
      let result = [];
      this.allAnimals.forEach(e => {
        if(!this.weightIn.third_weight_end_hour && parseFloat(e.third_weight) > 0) {
          result.push("Hora é obrigatória");
        }
      });
      return result;
    },
    has_errors_first_milking() {
      if(!this.weightIn.date) {
        return true;
      }
      else {
        return false;
      }
    },
    canSave() {
      const wrong = this.computedAnimals.filter(e => parseFloat(e.first_weight) <= 0);
      if(wrong.length) {
        return  false;
      } else {
        return true;
      }
    },
    computedGroups() {
      let groups = [];
      this.allAnimalsList.forEach(e => {
        if(e.group && /^f/i.test(e.gender || "")) {
          groups.push(e.group)
        }
      });
      let result = groups.filter((set => f => !set.has(f.id) && set.add(f.id))(new Set));
      return result;
    },
    computedRegimes() {
      if(this.regimes.length) {
        return this.regimes.map(e => ({...e, title:e.description}));
      } else {
        return [];
      }
    },
    checkLastControl() {
      return this.last_service?.last_service_date !== "-" ? true : false;
    },
    checkIfCanEdit() {
      let permition = false;
      const can_validate = this.user.roles.find(e => e.name === "service.validate");
      const user_kind = this.user.attributes.kind;
      if(user_kind === "admin" || user_kind === "partner" && can_validate) {
        permition = true;
      }
      if(user_kind === "admin" || user_kind === "partner" && !can_validate) {
        permition = true;
      }
      if(!user_kind === "admin" || !user_kind === "partner" && can_validate) {
        permition = false;
      }
      return permition;
    },
  },
  methods:{
    ...mapActions("service", [
      "actionGetSingleService", 
      "actionSaveDraft", 
      "actionCloseService", 
      "actionGetLastService",
      "actionValidateService",
      "actionGetServices",
      "actionSortAnimals"
    ]),
    ...mapActions("animals", [
      "actionGetAllAnimals", 
      "actionKillAnimal",
      "actionGetRegimes",
      "actionGetAnimalsReasons",
      "actionGetAnimalsReleased",
      "actionSaveKill",
      "actionGetBirthProductionInfo"
    ]),
    showClassification(id) {
      this.animalClassificationInfo.animal = 
      {
        date_classified:this.service_single.date_classified, 
        ...this.allAnimals.find(e => e.animal_id === id)
      };
      this.animalClassificationInfo.show = true;
    },
    async showBirthProductionInfo(animal) {
      await this.actionGetBirthProductionInfo(animal);
      this.animalBirthProductionInfo = animal;
      this.isModalBirthProductionInfo = true;
    },
    async setSort(param) {
      await this.actionSortAnimals({service_id:this.service_single.id, param:param});
      this.allAnimals = [];
      await this.loadAnimals();
    },
    // Alertas de produção (sistema do Rapha, N7), só para admin em serviço Finalizado: total da
    // pesagem ±40% da última aprovada ou ±20% da média; ignora 38/27 e pesagem com explicação.
    checkAverageWeight() {
      const podeAlertar = this.user.attributes.kind === "admin" && this.service_single.status === "Finalizado";
      this.allAnimals.filter(animal => !animal.lactation.find(a => a === "38" || a === "27")).forEach(animal => {
        if(!podeAlertar || animal.kind_explanation) return;
        const total = parseFloat(animal.first_weight || 0) + parseFloat(animal.second_weight || 0) + parseFloat(animal.third_weight || 0);
        animal.error = null;
        if(animal.last_production) {
          if(total >= animal.last_production * 1.4) { animal.error = "40% acima da última"; return; }
          if(total <= animal.last_production / 1.4) { animal.error = "40% abaixo da última"; return; }
        }
        if(animal.average_production) {
          if(total >= animal.average_production * 1.2) animal.error = "20% acima da média.";
          else if(total <= animal.average_production * 0.8) animal.error = "20% abaixo da média.";
        }
      });
      this.setStorage(this.allAnimals, true);
    },
    checkIfAllAnimalsHaveWeight() {
      const list = JSON.parse(localStorage.getItem("form-validate-service-list"));
      const withErrors = [];
      list.filter(animal => !animal.lactation.find(e => e === "38") && !animal.kind_explanation).forEach(e => {
        switch(true) {
          case (!e.first_weight > 0 && !e.second_weight > 0) :
            withErrors.push(e);
            break;
          case (!e.second_weight > 0 && !e.third_weight > 0) :
            withErrors.push(e);
            break;
          case (!e.third_weight > 0 && !e.first_weight > 0) :
            withErrors.push(e);
            break;
          default :
            withErrors.slice(0, withErrors.length);
        }
      });
      if(withErrors.length) {
        this.$toast.warning(`Os animais a seguir ${withErrors.map(e => {return e.animal.name}).join()} devem ter mais de uma ordenha preenchida`);
        return false;
      } else {
        return true;
      }
    },
    checkLactationOnFoot(item) {
      if(item.lact.find(e => e === "21")) {
        this.allAnimals.forEach(animal => {
          if(animal.animal_id === item.animal_id) {
            animal.on_foot = false;
          }
        })
        return true;
      }
    },
    parseDateInAmericanModal(date) {
      const [day,month,year] = date.toString().split("-");
      return year+"-"+month+"-"+day;
    },
    // Prazos entre pesagens (sistema do Rapha, confirmados pelo Altamir em 29/09/2026), pela
    // periodicidade da fazenda: sem pesagem anterior, do parto (mensal 5–45 / bimestral 5–75 dias);
    // com pesagem anterior, do último serviço (mensal 15–45 / bimestral 45–75). `ignoreIntervals`
    // = "Finalizar mesmo assim" (só os prazos; os erros de data/hora continuam valendo).
    validateIfCanCloseWithErrors(ignoreIntervals = false) {
      const day = 86400000;
      const serviceDate = new Date(this.weightIn.date).getTime();
      const firstWeightInService = new Date(this.weightIn.first_weight_date).getTime();
      const bimonthly = !!this.service_single.farm && this.service_single.farm.period_service === "bimonth";
      const invalidAnimals = [];
      if(!ignoreIntervals) {
        this.allAnimals.filter(animal => !animal.lactation.find(a => a === "38" || a === "27")).forEach(e => {
          const lastWeightIn = new Date(this.parseDateInAmericanModal(e.animal.last_weight)).getTime();
          const lastBirthDay = new Date(this.parseDateInAmericanModal(e.animal.last_birthday)).getTime();
          if(isNaN(lastWeightIn)) {
            const max = bimonthly ? 75 : 45;
            if(serviceDate < lastBirthDay + 5 * day || serviceDate > lastBirthDay + max * day) {
              invalidAnimals.push(e);
              this.firstAlertsModalText = `Os animais a seguir possuem intervalo de pesagem menor que 5 dias ou maior que ${max} dias após o último parto`;
            }
          } else {
            const [min, max] = bimonthly ? [45, 75] : [15, 45];
            if(serviceDate < lastWeightIn + min * day || serviceDate > lastWeightIn + max * day) {
              invalidAnimals.push(e);
              this.firstAlertsModalText = `Os animais a seguir possuem intervalo de pesagem menor que ${min} dias ou maior que ${max} dias após o último serviço`;
            }
            else if(firstWeightInService < lastBirthDay + 6 * day) {
              e.date_tooltip = "Os animais a seguir possuem intervalo de pesagem inferior a 6 dias da data de último parto";
            }
          }
        });
      }
      if(invalidAnimals.length) {
        this.showInvalidFirstWeightInInterval = true;
        this.invalidFirstWeightInAnimals = invalidAnimals;
        return false;
      } 
      else if(
        this.exhaustionMilkingDate.length ||
        this.exhaustionStartHourError.length ||
        this.exhaustionEndHourError.length || 
        this.firstMilkingDateErrors.length ||
        this.firstMilkingStartHourErrors.length ||
        this.firstMilkingEndHourErrors.length ||
        this.secondMilkingErrors.length ||
        this.secondMilkingStartHourErrors.length ||
        this.secondMilkingEndHourErrors.length ||
        this.thirdMilkingError.length ||
        this.thirdMilkingStartHourErrors.length ||
        this.thirdMilkingEndHourErrors.length
      ) {
        return false;
      }
      else {
        return true;
      }
    },
    validateFirstWeight() {
      const firstWeightInService = Math.round(new Date(this.weightIn.first_weight_date).getTime() / 1000);
      const serviceDate = Math.round(new Date(this.weightIn.date).getTime() / 1000);
      const invalidAnimals = [];
      this.allAnimals.filter(animal => !animal.lactation.find(a => a === "38" || a === "27")).forEach(e => {
        const animalLastWeightIn = Math.round(new Date(this.parseDateInAmericanModal(e.animal.last_weight)).getTime() / 1000);
        const animalLastBirthDay = Math.round(new Date(this.parseDateInAmericanModal(e.animal.last_birthday)).getTime() / 1000);
        // a última pesagem só conta se for ANTERIOR a este serviço: depois da 1ª validação (re-pesagem
        // do Parcialmente Aprovado) ela é a deste próprio serviço e a regra zerava as pesagens aprovadas
        const previousWeightIn = animalLastWeightIn < serviceDate;
        if(this.$route.name !== "Weight-in-edit" && previousWeightIn && firstWeightInService > (animalLastBirthDay + 518400) && firstWeightInService < (animalLastWeightIn + 1296000)) {
          invalidAnimals.push(e);
          e.lactation = ["38"];
          e.first_weight = null;
          e.second_weight = null;
          e.third_weight = null;
          e.exhaustion = null;
          e.on_foot = false;
          e.regime = "";
          this.firstAlertsModalText = "Os animais a seguir possuem intervalo de pesagem inferior a 15 dias da data de 1º ordenha";
        }
        else if(firstWeightInService < (animalLastBirthDay + 518400)) {
          e.lactation = ["38"];
          e.hide_milk_closure = true;
          invalidAnimals.push(e);
          this.firstAlertsModalText = "Os animais a seguir possuem intervalo de pesagem inferior a 6 dias da data de último parto";
        } 
        else if(serviceDate < (animalLastBirthDay + 518400)) {
          invalidAnimals.push(e);
          e.lactation = ["38"];
          e.first_weight = null;
          e.second_weight = null;
          e.third_weight = null;
          e.exhaustion = null;
          e.on_foot = false;
          e.regime = "";
        }
      });
      if(invalidAnimals.length) {
        this.showInvalidFirstWeightInInterval = true;
      }
      this.invalidFirstWeightInAnimals = invalidAnimals;
    },
    desaproveAll(reason) {
      const list = JSON.parse(localStorage.getItem("form-validate-service-list"));
      let results = [];
      list.forEach(e => {
        e.observation = reason;
        e.kind = "unaproved"
        e.approved = "unapproved";
        results.push(e);
      });
      this.setStorage(results, true);
      this.showRemoveModal = false;
    },
    checkIfIsApproved(animal) {
      if(this.$route.name === "Weight-in-edit" && isApprovedValue(animal.approved)) {
        return true;
      } else {
        return false;
      }
    },
    updateInterval(value) {
      this.modalAlertInterval = value;
    },
    checkIfWasReproved(item) {
      const list = JSON.parse(localStorage.getItem("form-validate-service-list"));
      const animalLastStorage = list.find(serviceAnimal => serviceAnimal.animal.id === item.animal_id);
      if(item.approved === "unapproved" && approvedLevel(animalLastStorage.approved) !== "unapproved") {
          this.animalToRemove = {...item, previous_approved: animalLastStorage.approved};
          this.showRemoveModal = true;
      } else {
        this.allAnimals.forEach(e => {
          if(e.animal_id === item.animal_id) {
            e.approved = item.approved;
          }
        });
        this.approvedKey = this.approvedKey + 1;
        this.setStorage(this.allAnimals, true);
      }
    },
    removeAnimalFromService(item) {
      this.showRemoveModal = true;
      this.animalToRemove = item;
    },
    closeRemoveModal(animal) {
      this.showRemoveModal = false;
      if(!animal) return; // o X do modal fecha sem animal (nada a atualizar)
      this.allAnimals.forEach(e => {
        if(e.animal_id === animal.animal_id) {
          e.hide_modal = true;
          e.approved = animal.approved;
        }
      });
      this.approvedKey = this.approvedKey + 1;
      this.setStorage(this.allAnimals, true);
    },
    getObservation(data) {
      this.allAnimals.forEach(animal =>  {
        if(animal.id === data.animal.item_id) {
          animal.observation = data.reason;
          animal.kind = "unaproved"
          animal.approved = "unapproved";
        }
      });
      this.setStorage(this.allAnimals, true);
    },
    checkLactaction(item) {
      if(item.lact.find(e => e === "38")) {
        return true
      }
      else {
        return false
      }
    },
    //controles do modal de explicações
    showExplanationsModal(item) {
      this.showExplanations = true;
      this.animalToExplanations = item;
    },
    closeModalExplanations() {
      this.showExplanations = false;
      this.animalToExplanations = {};
    },
    saveExplanations(data) {
      this.allAnimals.forEach(e => {
        if(e.animal_id === data.animalId) {
          e.explanations = data.explanations;
        }
      })
      const list = JSON.parse(localStorage.getItem("form-validate-service-list"));
      list.forEach(e => {
        if(e.animal_id === data.animalId) {
          e.explanations = data.explanations;
        }
      })
      localStorage.setItem("form-validate-service-list", JSON.stringify(list));
    },
    // O select guarda o nível (string); "" = ainda não avaliado (o back aceita os 4 níveis e "").
    approvedToSend(e) {
      return e.approved === undefined ? undefined : approvedLevel(e.approved);
    },
    //Esse metododo aplica o status escolhido a todos os animais (sistema do Rapha)
    approveAll(value) {
      this.approvedAllAnimals = value;
      if(value === "unapproved") {
        this.animalToRemove = {name:"todos", approved:value};
        this.showRemoveModal = true;
        return;
      }
      const list = JSON.parse(localStorage.getItem("form-validate-service-list"));
      list.forEach(e => {
        // seca/sem controle (38/27) e encerramento não têm pesagem por definição: aprova (revisão J4)
        const semPesagemEsperada = (e.lactation || []).some(a => a === "38" || a === "27") || !!e.date_explanation || !!e.kind_explanation;
        const semPesagem = value === "with_weight" && !semPesagemEsperada && this.calculatorWeight(e) < 2;
        // "Aprovar todos com pesagem": sem pesagem (< 2 kg) fica reprovado com o motivo
        e.approved = semPesagem ? "unapproved" : (value === "with_weight" ? "approved" : value);
        e.observation = semPesagem ? "Sem pesagem informada." : "";
        if(semPesagem) e.kind = "unaproved";
      });
      this.setStorage(list, true);
    },
    calculatorWeight(animal) {
      return parseFloat(animal.first_weight || 0) + parseFloat(animal.second_weight || 0) +
        parseFloat(animal.third_weight || 0) + parseFloat(animal.exhaustion || 0);
    },
    //Esse metodo retorna a cor do status 
    returnColorForStatus(status) {
      let result = "";
      if(status) {
        switch(status) {
          case "Pendente":
            result = "#1f6fd1"
            break;
          case "Fechado":
            result = "#127a5c";
            break;
          case "Em preenchimento":
            result = "#56707a";
            break;
          case "Validado":
            result = "#2e7d32";
            break;
          case "Classificado":
            result = "#9044eb";
            break;
            default:
              result = "#b45f06";
        }
        return result;
      } else {
        return "#FFFFFF"
      }
    },
    setRegime(item) {
      let list = []
      this.allAnimals.forEach(e => {
        if(e.id === item.item_id) {
          e.regime = item.regime;
        }
        if(!e.lactation.length) {
          delete e.low;
          delete e.error_msg;
        }
        list.push(e);
      });
      this.setStorage(list, true);
    },
    setOnFoot(item) {
      this.allAnimals.forEach(e => {
        if(e.id === item.item_id) {
          e.on_foot = item.on_foot;
        }
      });
      this.setStorage(this.allAnimals, true);
    },
    setEmpty(item) {
      this.allAnimals.forEach(e => {
        if(e.id === item.item_id) {
          e.exhaustion = item.empty.replace(",", ".");
        }
      });
      this.setStorage(this.allAnimals, true);
      this.checkAverageWeight();
    },
    setLot(item) {
      this.allAnimals.forEach(e => {
        if(e.id === item.item_id) {
          e.lot = item.lot;
        }
      });
      this.setStorage(this.allAnimals, true);
    },
    setFirst(item) {
      this.allAnimals.forEach(e => {
        if(e.id === item.item_id) {
          e.first_weight = item.first_weight !== "" ? item.first_weight.replace(",", ".") : "0";
          if(parseFloat(e.first_weight) !== 0 && (e.lactation.length || e.regime.length)) {
            delete e.low;
            delete e.error_msg;
          }
          const firstSubStr = e.first_weight.toString().replace(",", ".");
          const secondSubStr = e.second_weight.toString().replace(",", ".");
          const thirdSubStr = e.third_weight.toString().replace(",", ".");
          /* if(parseFloat(firstSubStr) + parseFloat(secondSubStr) + parseFloat(thirdSubStr) >= 40) {
            e.low = " ";
            e.error_msg = "Ordenha possui mais de 40kg. Entre em contato com a equipe SCL";
          }
          else */ if(parseFloat(firstSubStr) + parseFloat(secondSubStr) + parseFloat(thirdSubStr) < 2) {
            e.low = " ";
            e.error_msg = "Soma das ordenhas menor que 2kg, lactação será encerrada por baixa produção";
          }
          else if(!e.lactation.length && !e.regime.length) {
            e.low = " ";
            e.error_msg = "Animais com ordenha informada devem possuir lactação ou regime";
          }
        }
      });
      this.setStorage(this.allAnimals, true);
      this.checkAverageWeight();
    },
    setSecond(item) {
      this.allAnimals.forEach(e => {
        if(e.id === item.item_id) {
          e.second_weight = item.second !== "" ? item.second.replace(",", ".") : "0";
          if(parseFloat(e.second_weight) !== 0 && (e.lactation.length || e.regime.length)) {
            delete e.low;
            delete e.error_msg;
          }
          const firstSubStr = e.first_weight.toString().replace(",", ".");
          const secondSubStr = e.second_weight.toString().replace(",", ".");
          const thirdSubStr = e.third_weight.toString().replace(",", ".");
          /* if(parseFloat(firstSubStr) + parseFloat(secondSubStr) + parseFloat(thirdSubStr) >= 40) {
            e.low = " ";
            e.error_msg = "Ordenha possui mais de 40kg. Entre em contato com a equipe SCL"
          }
          else */ if(parseFloat(firstSubStr) + parseFloat(secondSubStr) + parseFloat(thirdSubStr) < 2) {
            e.low = " ";
            e.error_msg = "Soma das ordenhas menor que 2kg, lactação será encerrada por baixa produção"
          }
          else if(!e.lactation.length && !e.regime.length) {
            e.low = " ";
            e.error_msg = "Animais com ordenha informada devem possuir lactação ou regime"
          }
        }
      });
      this.setStorage(this.allAnimals, true);
      this.checkAverageWeight();
    },
    setThird(item) {
      this.allAnimals.forEach(e => {
        if(e.id === item.item_id) {
          e.third_weight = item.third !== "" ? item.third.replace(",", ".") : "0";
           if(parseFloat(e.third_weight) !== 0 && (e.lactation.length || e.regime.length)) {
            delete e.low;
            delete e.error_msg;
          }
          const firstSubStr = e.first_weight.toString().replace(",", ".");
          const secondSubStr = e.second_weight.toString().replace(",", ".");
          const thirdSubStr = e.third_weight.toString().replace(",", ".");
          /* if(parseFloat(firstSubStr) + parseFloat(secondSubStr) + parseFloat(thirdSubStr) >= 40) {
            e.low = " ";
            e.error_msg = "Ordenha possui mais de 40kg. Entre em contato com a equipe SCL"
          }
          else  */if(parseFloat(firstSubStr) + parseFloat(secondSubStr) + parseFloat(thirdSubStr) < 2) {
            e.low = " ";
            e.error_msg = "Soma das ordenhas menor que 2kg, lactação será encerrada por baixa produção"
          }
          else if(!e.lactation.length && !e.regime.length) {
            e.low = " ";
            e.error_msg = "Animais com ordenha informada devem possuir lactação ou regime"
          }
        }
      });
      this.setStorage(this.allAnimals, true);
      this.checkAverageWeight();
    },
    setStorage(animals, reset) {
      let results = [];
      const list = JSON.parse(localStorage.getItem("form-validate-service-list"));
      list.forEach(storage => {
        animals.forEach(animal => {
          if(storage.animal_id === animal.animal_id) {
            storage = animal
          }
        })
        results.push(storage);
      });
      localStorage.setItem("form-validate-service-list", JSON.stringify(results));
      if(reset) {
        this.allAnimals = [];
        this.allAnimals = results;
      }
    },
    setLact(item) {
      let newAnimalsResult = [];
      this.allAnimals.forEach(e => {
        if(e.id === item.item_id) {
          e.lactation = item.lact;
          if(parseFloat(e.first_weight) !== 0 || parseFloat(e.second_weight) !== 0 || parseFloat(e.third_weight) !== 0) {
            if(e.lactation.length || e.regime.length) {
              delete e.low;
              delete e.error_msg;
            }
          }
          const resetAttr = item.lact.filter(lact => lact === "38");
          if(resetAttr.length) {
            e.first_weight = 0;
            e.second_weight = 0;
            e.third_weight = 0;
            e.exhaustion = 0;
            e.on_foot = false;
            e.regime = "";
            delete e.low;
            delete e.error_msg;
          }
          const hasChildren = item.lact.filter(lact => lact === "12");
          if(hasChildren.length && !item.lact.filter(lact => lact === "12" || lact === "38")) {
            e.on_foot =  true;
          }
        }
        newAnimalsResult.push(e);
      });
      this.setStorage(newAnimalsResult, true);
      const validated = item.lact.filter(lact => lact === "10" || lact === "38");
      if(validated.length > 0) {
        const lactation = this.explanations.find(e => e.id === validated[0]);
        this.computedExplanations.push(lactation);
        let list = [];
        this.allAnimals.forEach(e => {
          if(e.id === item.item_id) {
            e.lactation = validated;
          }
          list.push(e);
        });
        this.setStorage(list, true);
      }
    },
    
    validation() {
      const list = JSON.parse(localStorage.getItem("form-validate-service-list"));
      let newResults = [];
      list.forEach(storageItem => {
        this.allAnimals.forEach(animal => {
          if(storageItem.id === animal.id) {
            storageItem = animal;
          }
        });
        newResults.push(storageItem);
      });
      const animals = newResults.filter(e => e.animal.active === true  && !e.lactation.find(a => a === "38" || a === "27")).filter(
        e => parseFloat(e.first_weight) === 0 && parseFloat(e.second_weight) === 0 && parseFloat(e.third_weight) === 0
      );
      const animalsWithMAx = newResults.filter(e => e.animal.active === true && !e.lactation.find(a => a === "38" || a === "27")).filter( e =>
        parseFloat(e.first_weight) >= 40 || parseFloat(e.second_weight) >= 40 ||
        parseFloat(e.third_weight) >= 40
      );
      const animalsWithMin = newResults.filter(e => e.animal.active === true && !e.lactation.find(a => a === "38" || a === "27")).filter( e =>
       parseFloat(e.first_weight) + parseFloat(e.second_weight) +
       parseFloat(e.third_weight) + parseFloat(e.exhaustion) <= 2
       );
       let result = null;
       switch(true) {
        case (animalsWithMAx.length > 0) : {
          let results = [];
          this.allAnimals.forEach(list => {
           /*  animalsWithMAx.forEach(animal => {
              if(list.animal_id === animal.animal_id) {
                list = {...animal,low:" ", error_msg:"Ordenha (1, 2 ou 3 ou esgota) possui mais de 40kg. Entre em contato com a equipe SCL"};
              }
            }); */
            results.push(list);
          });
          this.setStorage(results, true);
          result = true;
          break;
        }
        case (animals.length > 0) : {
          let results = [];
          this.allAnimals.forEach(list => {
            animals.forEach(animal => {
              if(list.animal_id === animal.animal_id) {
                list = {...animal,low:" ", error_msg:"Precisa possuir uma ou mais pesagens"};
              }
            });
            results.push(list);
          });
          this.setStorage(results, true);
          result = true;
          break;
        }
        case (animalsWithMin.length > 0) : {
          let results = [];
          this.allAnimals.forEach(list => {
            animalsWithMin.forEach(animal => {
              if(list.animal_id === animal.animal_id) {
                list = {...animal,low:" ", error_msg:"Soma das ordenhas menor que 2kg, lactação será encerrada por baixa produção"};
              }
            });
            results.push(list);
          });
          this.setStorage(results, true);
          result = true;
          break;
        }
        default : {
           let results = [];
          this.allAnimals.forEach(list => {
              delete list.low;
              delete list.error_msg;
              results.push(list);
          });
          this.setStorage(results, true);
          result = true;
        }
      }
      return result;
    },
    async saveDraft() {
      if(!this.validation()) return;
      let list = JSON.parse(localStorage.getItem("form-validate-service-list"));
      let newResults = [];
      list.forEach(storageItem => {
        this.allAnimals.forEach(animal => {
          if(storageItem.id === animal.id) {
            storageItem = animal;
          }
        });
        newResults.push(storageItem);
      });
       const payload = {
        id:this.weightIn.id,
        person_id:this.weightIn.person.id,
        farm_id:this.weightIn.farm.id,
        partner:this.weightIn.partner.id,
        date:this.weightIn.date,
        observation:!this.weightIn.observation ? "" : this.weightIn.observation,
        //farm será passado somente para ser exibido no header na action de put ele sera apagado antes do envio do json
        farm:this.weightIn.farm,
        //datas
        exhaustion_date:this.weightIn.exhaustion_date,
        exhaustion_start_hour:this.weightIn.exhaustion_start_hour,
        exhaustion_end_hour:this.weightIn.exhaustion_end_hour,

        first_weight_date:this.weightIn.first_weight_date,
        first_weight_start_hour:this.weightIn.first_weight_start_hour,
        first_weight_end_hour:this.weightIn.first_weight_end_hour,

        second_weight_date:this.weightIn.second_weight_date,
        second_weight_start_hour:this.weightIn.second_weight_start_hour,
        second_weight_end_hour:this.weightIn.second_weight_end_hour,

        third_date:this.weightIn.third_weight_date,
        third_start_hour:this.weightIn.third_weight_start_hour,
        third_end_hour:this.weightIn.third_weight_end_hour,
      };
      payload.service_animals_attributes = [
        ...newResults.map(e => ({
          animal_id:e.animal_id,
          fat:e.fat,
          lactose:e.lactose,
          ccs:e.ccs,
          protein:e.protein,
          classified_comment:e.classified_comment,
          id:e.id ? e.id : undefined,
          kind:e.kind,
          regime:e.regime,
          on_foot:e.on_foot,
          lot:e.lot,
          first_weight:e.first_weight === "0" ? 0 : e.first_weight,
          second_weight:e.second_weight === "0" ? 0 : e.second_weight,
          third_weight:e.third_weight === "0" ? 0 : e.third_weight,
          exhaustion:e.exhaustion,
          observation:e.observation,
          explanations:e.explanations ? e.explanations.map(e => {return e.id}) : undefined,
          lactation:e.lactation.join(),
          approved:this.approvedToSend(e),
          date_explanation:e.date_explanation ? e.date_explanation : null,
          kind_explanation:e.kind_explanation ? e.kind_explanation : null
        }))
      ]
      try {
        await this.actionSaveDraft(payload);
        this.$toast.success("Rascunho da pesagem salvo !");
        return true;
      } catch(error) {
        this.$toast.error(`${error}`)
        return false;
      }
    },
    setDietForAll(value) {
      let list = JSON.parse(localStorage.getItem("form-validate-service-list"));
      list.forEach(e => {
        e.regime =  value;
      });
      localStorage.setItem("form-validate-service-list", JSON.stringify(list));
      this.allAnimals.forEach(e => {
        e.regime = value;
      });
    },
    setExplanationsForAll(value) {
      let list = JSON.parse(localStorage.getItem("form-validate-service-list"));
      list.forEach(e => {
        e.lact = value;
        if(value.filter(e => e === "12").length) {
          e.on_foot = true;
        }
      });
      localStorage.setItem("form-validate-service-list", JSON.stringify(list));
      this.allAnimals.forEach(e => {
        e.lactation = value;
        if(value.filter(e => e === "12").length) {
          e.on_foot = true;
        }
      });
    },
    setBirthForAll() {
      let list = JSON.parse(localStorage.getItem("form-validate-service-list"));
      list.forEach(e => {
        e.on_foot = this.allHasChildren;
      });
      localStorage.setItem("form-validate-service-list", JSON.stringify(list));
      this.allAnimals.forEach(e => {
        e.on_foot = this.allHasChildren;
      })
    },
    //Função responsável por salvar pesagem
    // `ignoreIntervals === true` só vem do "Finalizar mesmo assim" (o @click passa o evento).
    async saveWeightIn(ignoreIntervals) {
      this.submitedOnSave = true;
      if(!this.validation()) return;
      if(!this.validateIfCanCloseWithErrors(ignoreIntervals === true)) return;
        try {
        let list = JSON.parse(localStorage.getItem("form-validate-service-list"));
        let continueSaving = true;
        this.alertTwoWeightAnimals = [];
        // cada animal uma vez (antes era checado dentro de um laço duplo e aparecia N vezes no alerta)
        list.forEach(storageItem => {
          const animal = this.allAnimals.find(a => a.id === storageItem.id) || storageItem;
          if(!animal.date_explanation && 
            (!animal.lactation.length || animal.lactation.find(e => e !== "38")) && 
            (parseFloat(animal.first_weight || 0) + parseFloat(animal.second_weight || 0) + parseFloat(animal.third_weight || 0)) < 2) {
            this.showAlertTwoWeight = true;
            this.alertTwoWeightAnimals.push(animal);
            continueSaving = false;
          }
        });
        const closedLactations = list.filter(
          e => e.kind_explanation === 5 || 
          e.kind_explanation === 7 || 
          e.kind_explanation === 8
        );
        for(let i = 0; i < closedLactations.length; i++) {
          const killPayload = {
            animal_id:closedLactations[i].animal_id,
            event_at:closedLactations[i].date_explanation,
          }
          if(closedLactations[i].kind_explanation === 5) {
            killPayload.kind = "18";
          }
          else if(closedLactations[i].kind_explanation === 7) {
            killPayload.kind = "20";
          }
          else if(closedLactations[i].kind_explanation === 8) {
            killPayload.kind = "19";
          }
          await this.actionSaveKill(killPayload);
        }
        if(continueSaving) {
          // rascunho recusado (ex.: 422) nao pode fechar o servico com dados velhos
          if(!(await this.saveDraft())) return;
          await this.actionCloseService(this.weightIn);
          this.$toast.success("Serviço finalizado com sucesso !");
          this.$router.push({name:"Services-list"}); 
        }
      } catch(error) {
        this.$toast.error(`${error}`)
      }
    },
    saveWeightInRegardless() {
      this.showInvalidFirstWeightInInterval = false;
      this.saveWeightIn(true);
    },
    //Esse metodo valida o serviço/pesagem
    async validateWeightIn() {
      if(!this.validation()) return;
      try {
        if(!(await this.saveDraft())) return;
        await this.actionValidateService(this.weightIn.id);
        this.modalSaved = true;
        // resumo: a lista completa é pesada (trava a API) e esta tela não usa as pesagens dela
        await this.actionGetServices({page:1, summary:true});
      } catch(error) {
        this.$toast.error(`${error}`);
        return;
      }
    },
    //fazer funções com os animais do storage 
    checkLastAnimalControl() {
      const storageAnimals = JSON.parse(localStorage.getItem("form-validate-service-list"));
      storageAnimals.filter(animal => !animal.lactation.find(e => e === "38")).forEach(animal => {
        if(animal.animal.last_weight !== "N/D") {
          const last_control = Math.round(new Date(this.parseDate(animal.animal.last_weight)).getTime() / 1000);
          const last_birthday = Math.round(new Date(this.parseDate(animal.animal.last_birthday)).getTime() / 1000);
          const thisService = Math.round(new Date(this.weightIn.date).getTime() / 1000);
          //6480000 é o equivalente a 75 dias em unix timestamp
          if(!isNaN(thisService) && thisService > (last_control + 6480000) && thisService < (last_birthday + 34560000)) {
            animal.error = "Animal está fora do intervalo de 15 a 75 dias";
          }
          else if(!isNaN(thisService) && thisService >= (last_birthday + 34560000) && thisService < (last_birthday + 60480000)) {
            animal.date_tooltip = `${animal.animal.name} está em ${parseInt((thisService - last_birthday) / 86400)} dias em lactação`;
          }
          /* else if(!isNaN(thisService) && thisService >= (last_birthday + 60480000)) {
            const previousDate = new Date((last_control + 1296000) * 1000);
            let day = previousDate.getDate();
            let month = previousDate.getMonth() + 1;
            const year = previousDate.getFullYear();
            if(day <= 9) {
              day = "0" + day;
            }
            if(month <= 9) {
              month = "0" + month;
            }
            animal.error = "Duração da lactação igual ou maior que 700 dias";
            animal.kind_explanation = 1;        
            animal.date_explanation = year+"-"+month+"-"+day; 
          } */
          else if(!isNaN(last_control) && thisService > (last_control + 6480000)) {
            animal.error = "Intervalo dos controles maior que 75 dias";
          }
          else if(!isNaN(last_control) && thisService > (last_control + 6480000)) {
            animal.kind_explanation = 11;
            animal.date_explanation = this.weightIn.date;
          }
        }
        else {
          /* const today = Math.round(new Date(this.weightIn.date).getTime() / 1000);
          const last_birthday = Math.round(new Date(this.parseDate(animal.animal.last_birthday)).getTime() / 1000);
          if(!isNaN(last_birthday) && today > (last_birthday + 6480000)) {
            animal.kind_explanation = 11;
            animal.date_explanation = this.weightIn.date; 
          }
          else if(today > (last_birthday + 6480000)) {
            animal.error = "Intervalo dos controles maior que 75 dias";
          } */
        }
      });
      this.setStorage(storageAnimals, true)
    },
    //Esse metodo carrega os animais do serviço escolhido
    async loadAnimals() {
      if(this.service_single.service_animals) {
        const reweigh = this.$route.name === "Weight-in-create" && this.user.attributes.kind === "partner" &&
          (this.service_single.status === "Parcialmente Aprovado" || this.service_single.status === "Reprovado");
        if(this.$route.name === "Weight-in-edit" || reweigh) {
          // edição de validado: só os não aprovados; re-pesagem do controlador (sistema do Rapha):
          // reprovados, não avaliados e "com pendência"
          const keep = reweigh ? (a => ["unapproved", "", "approved_with_pending"].includes(approvedLevel(a.approved)))
                               : (a => !isApprovedValue(a.approved));
          this.allAnimals.push(...this.service_single.service_animals.filter(keep).map(e => 
            ({...e, 
              first_weight: e.first_weight === null ? 0 : e.first_weight,
              second_weight: e.second_weight === null ? 0 : e.second_weight,
              third_weight: e.third_weight === null ? 0 : e.third_weight,
              lactation:!e.lactation.length ? [] : e.lactation.split(","), 
              search_key:e.animal.code + " " + e.animal.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "") + " " + e.animal.register, 
              animal_id:e.animal.id,
              hide_modal:true,
              approved: approvedLevel(e.approved)
          })));
        } else {
        this.allAnimals.push(...this.service_single.service_animals.map(e => 
          ({...e, 
            first_weight: e.first_weight === null ? 0 : e.first_weight,
            second_weight: e.second_weight === null ? 0 : e.second_weight,
            third_weight: e.third_weight === null ? 0 : e.third_weight,
            lactation:!e.lactation.length ? [] : e.lactation.split(","), 
            search_key:e.animal.code + " " + e.animal.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "") + " " + e.animal.register, 
            animal_id:e.animal.id,
            hide_modal:true,
            approved: approvedLevel(e.approved)
          })));
        }
        localStorage.setItem("form-validate-service-list", JSON.stringify(this.allAnimals));
        this.total_pages = Math.ceil(this.allAnimals.length / this.valuePerPage);
        this.total_items = this.allAnimals.length;
        this.checkLastAnimalControl();
        this.allAnimals = this.allAnimals.filter((a, i) => i < this.valuePerPage);
        this.in_page = this.valuePerPage;
        this.validation();
      }
    },
    openKillsModal(animal) {
      this.animalToKill = this.allAnimals.find(e => e.animal_id === animal.animal_id);
      this.isModalKills = true;
    },
    closeModalKill(data) {
      if(data) {
        let results = [];
        this.allAnimals.forEach(animal => {
          if(animal.animal_id === data.animal_id) {
            animal.date_explanation = data.event_at;
            animal.kind_explanation = data.kind;
          }
          results.push(animal);
        });
        localStorage.setItem("form-validate-service-list", JSON.stringify(results));
        this.checkIfHaveBlankAnimals();
      }
      this.tableKey = this.tableKey + 1;
      this.isModalKills = false;
    },
    //Update de animais adicionados
    updateAnimalsList(animal) {
      const payload = {animal:{...animal}};
      this.allAnimals.push(payload);
    },
    //Esse metodo faz a pesquisa do animais
    searchAnimal(data) {
      this.query = data;
      const validateAnimalsList = JSON.parse(localStorage.getItem("form-validate-service-list"));
      if(data.length) {
        const finded = validateAnimalsList.filter(e => e.search_key.toLowerCase().includes(data) || e.search_key.includes(data));
        this.allAnimals = finded;
        this.total_pages = Math.ceil(finded.length / this.in_page);
      } else {
        this.allAnimals = validateAnimalsList;
        this.total_pages = Math.ceil(this.allAnimals.length / this.in_page);
      }
    },
    //Esse metodo cancela o encerramento e retorna os atirbutos para edição
    cancelClosure(animal) {
      this.allAnimals.forEach(e => {
        if(e.id === animal.item_id) {
          e.date_explanation = undefined;
          e.kind_explanation = undefined;
          if(e.first_weight === 0 && e.second_weight === 0 && e.third_weight === 0) {
            e.low = " ";
            e.error_msg = "Precisa possuir uma ou mais pesagens";
          }
        }
      });
    },
    checkIfHaveBlankAnimals() {
      const storageAnimals = JSON.parse(localStorage.getItem("form-validate-service-list"));
      if(storageAnimals.filter(e => !e.kind_explanation && e.error_msg && e.error_msg !== "Soma das ordenhas menor que 2kg, lactação será encerrada por baixa produção").length) {
        this.blankAnimals = true;
      } else {
        this.blankAnimals = false;
      }
    }
  },
  watch: {
    "weightIn.date": async function(val) {
      if(val) {
        await this.actionGetLastService(this.weightIn.id);
        this.weightIn.first_weight_date = val;
        this.checkLastAnimalControl();
      }
    },
    "weightIn.first_weight_date": async function(val) {
      if(val) {
        await this.validateFirstWeight();
      }
    },
    allAnimals() {
      this.checkIfHaveBlankAnimals();
    },
  },
  async mounted() {
    await this.actionGetSingleService(this.$route.params.id);
    this.allAnimalsList = await this.actionGetAllAnimals(this.service_single.farm.id);
    await this.actionGetRegimes();
    await this.actionGetAnimalsReasons();
    this.weightIn = {
      ...this.service_single,
      exhaustion_start_hour: this.service_single.exhaustion_start_hour === "-" ? null : this.service_single.exhaustion_start_hour,
      exhaustion_end_hour: this.service_single.exhaustion_end_hour === "-" ? null : this.service_single.exhaustion_end_hour,
      exhaustion_date: this.service_single.exhaustion_date === "-" ? null : this.parseDate(this.service_single.exhaustion_date),
      first_weight_date: this.service_single.first_weight_date === "-" ? null : this.parseDate(this.service_single.first_weight_date),
      first_weight_start_hour: this.service_single.first_weight_start_hour === "-" ? null : this.service_single.first_weight_start_hour,
      first_weight_end_hour: this.service_single.first_weight_end_hour === "-" ? null : this.service_single.first_weight_end_hour,
      second_weight_date: this.service_single.second_weight_date === "-" ? null : this.parseDate(this.service_single.second_weight_date),
      second_weight_start_hour: this.service_single.second_weight_start_hour === "-" ? null : this.service_single.second_weight_start_hour,
      second_weight_end_hour: this.service_single.second_weight_end_hour === "-" ? null : this.service_single.second_weight_end_hour,
      third_weight_date: this.service_single.third_date === "-" ? null : this.parseDate(this.service_single.third_date),
      third_weight_start_hour: this.service_single.third_start_hour === "-" ? null : this.service_single.third_start_hour,
      third_weight_end_hour: this.service_single.third_end_hour === "-" ? null : this.service_single.third_end_hour,
    }
    this.loadAnimals();
    if(this.checkIfCanValidate && this.user.attributes.kind === 'admin' && this.weightIn.status === "Finalizado") {
      this.headersForTable.unshift({text:"Aprovado", value:"approved", has_slot:true, header_slot:"approvedSwitch", type:"boolean", approve_switch:true, index:12});
    }
    this.headersForTable.sort((head1, head2) => head1.index + head2.index);
  },
}
</script>

<style scoped>
  h5 {
    margin-bottom: 20px;
  }
  .table-item {
    height: 50px;
  }
  .round-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .buttonAdd {
    background-color:var(--medium-blue) !important;
    color: white !important;
  }
  .status {
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size:1rem;
    padding:5px 20px;
    border-radius: 10px;
    width: fit-content;
  }

  .v-text-field.v-text-field--solo .v-input__control {
    max-height: 10px;
  }

  .v-autocomplete .v-input__control .v-text-field__details {
    display: none !important;
  }

  .classification-icon {
    font-size: 1.4rem;
  }

  @media screen and (max-width:1500px) {
    .select-adjust {
      max-width: 100px;
    }
  }

  @media screen and (max-width:990px) {
    .table-wrapper {
      max-width: 80vw;
      overflow-x:scroll;
    }
  }
</style>